(function(){'use strict';
  var stickyHeader=document.querySelector('.site-header.is-sticky');
  if(stickyHeader&&stickyHeader.parentElement)stickyHeader.parentElement.classList.add('lumera-header-sticky');
  document.querySelectorAll('[data-product-gallery]').forEach(function(gallery){
    var main=gallery.querySelector('[data-product-main-image]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function(thumb){
      thumb.addEventListener('click',function(){
        if(main){main.src=thumb.dataset.imageSrc;main.srcset='';main.alt=thumb.dataset.imageAlt||'';}
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function(b){b.classList.remove('is-active');b.setAttribute('aria-pressed','false');});
        thumb.classList.add('is-active');thumb.setAttribute('aria-pressed','true');
      });
    });
  });
  document.querySelectorAll('[data-variant-selector]').forEach(function(select){
    select.addEventListener('change',function(){
      var selected=select.options[select.selectedIndex];
      var wrap=select.closest('[data-product-form-wrap]');
      if(!wrap)return;
      var price=wrap.querySelector('[data-product-price]');
      if(price&&selected.dataset.price)price.textContent=selected.dataset.price;
      var button=wrap.querySelector('[data-add-button]');
      if(button){var available=selected.dataset.available==='true';button.disabled=!available;button.textContent=available?button.dataset.addLabel:button.dataset.soldLabel;}
      if(window.history&&window.history.replaceState){var u=new URL(window.location.href);u.searchParams.set('variant',selected.value);window.history.replaceState({},'',u.toString());}
    });
  });
  document.querySelectorAll('[data-mobile-menu] a').forEach(function(link){link.addEventListener('click',function(){var d=link.closest('details');if(d)d.open=false;});});
})();
